<template>
  <div id="property-modal" class="modal"  v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2>得意先情報設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div v-if="isInput" class="data-area">
        <ul>
          <li>
            <span class="label">得意先名<span class="required">【必須】</span></span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessName">
              <input type="text" v-else v-model="businessName" placeholder="得意先名">
              <div class="validate_error_messages">{{ validateErrorMessages.businessName }}</div>
            </div>
          </li>
          <li>
            <span class="label">得意先コード<span class="required">【必須】</span></span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessCode">
              <input type="text" v-else v-model="businessCode" placeholder="得意先コード">
              <div class="validate_error_messages">{{ validateErrorMessages.businessCode }}</div>
            </div>
          </li>
          <li>
            <span class="label">得意先部署</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessDepartment">
              <input type="text" v-else v-model="businessDepartment" placeholder="得意先部署">
              <div class="validate_error_messages">{{ validateErrorMessages.businessDepartment }}</div>
            </div>
          </li>
          <li>
            <span class="label">得意先説明</span>
            <div class="input-normal">
              <textarea v-if="editBusinessData" v-model="editBusinessData.businessCaption"/>
              <textarea v-else v-model="businessCaption" placeholder="得意先説明"/>
              <div class="validate_error_messages">{{ validateErrorMessages.businessCaption }}</div>
            </div>
          </li>
          <li>
            <span class="label">国</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessCountry">
              <input type="text" v-else v-model="businessCountry" placeholder="国">
            </div>
            <span class="label">郵便番号</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPostcd">
              <input type="text" v-else v-model="businessPostcd" placeholder="郵便番号">
            </div>
          </li>
          <li>
            <div class="validate_error_messages">{{ validateErrorMessages.businessCountry }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.businessPostcd }}</div>
          </li>
          <li>
            <span class="label">都道府県</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessState">
              <input type="text" v-else v-model="businessState" placeholder="都道府県">
            </div>
            <span class="label">市区町村</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessCity">
              <input type="text" v-else v-model="businessCity" placeholder="市区町村">
            </div>
          </li>
          <li>
            <div class="validate_error_messages">{{ validateErrorMessages.businessState }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.businessCity }}</div>
          </li>
          <li>
            <span class="label">その他住所/番地</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessStreet">
              <input type="text" v-else v-model="businessStreet" placeholder="その他住所/番地">
              <div class="validate_error_messages">{{ validateErrorMessages.businessStreet }}</div>
            </div>
          </li>
          <li>
            <span class="label">建物名</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessBuilding">
              <input type="text" v-else v-model="businessBuilding" placeholder="建物名">
            </div>
            <span class="label">階数</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessFloor">
              <input type="text" v-else v-model="businessFloor" placeholder="階数">
            </div>
          </li>
          <li>
            <div class="validate_error_messages">{{ validateErrorMessages.businessBuilding }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.businessFloor }}</div>
          </li>
          <li>
            <span class="label">電話番号</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessTel">
              <input type="text" v-else v-model="businessTel" placeholder="電話番号">
            </div>
            <span class="label">FAX番号</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessFax">
              <input type="text" v-else v-model="businessFax" placeholder="FAX番号">
            </div>
          </li>
          <li>
            <div class="validate_error_messages">{{ validateErrorMessages.businessTel }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.businessFax }}</div>
          </li>
          <hr>
          <li><span class="parson-label">【担当者】</span></li>
          <li>
            <span class="label">名前</span>
            <span class="sub-label">姓</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonLastName1">
              <input type="text" v-else v-model="businessPersonLastName1" placeholder="姓">
            </div>
            <span class="sub-label">名</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonFirstName1">
              <input type="text" v-else v-model="businessPersonFirstName1" placeholder="名">
            </div>
          </li>
          <li>
            <div class="validate_error_messages">{{ validateErrorMessages.businessPersonLastName1 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.businessPersonFirstName1 }}</div>
          </li>
          <li>
            <span class="label">フリガナ</span>
            <span class="sub-label">セイ</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonLastNameKana1"
                @input="editBusinessData.businessPersonLastNameKana1=inputRestKana($event)">
              <input type="text" v-else v-model="businessPersonLastNameKana1" placeholder="セイ"
                @input="businessPersonLastNameKana1=inputRestKana($event)">
            </div>
            <span class="sub-label">メイ</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonFirstNameKana1"
                @input="editBusinessData.businessPersonFirstNameKana1=inputRestKana($event)">
              <input type="text" v-else v-model="businessPersonFirstNameKana1" placeholder="メイ"
                @input="businessPersonFirstNameKana1=inputRestKana($event)">
            </div>
          </li>
          <li>
            <div class="validate_error_messages">{{ validateErrorMessages.businessPersonLastNameKana1 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.businessPersonFirstNameKana1 }}</div>
          </li>
          <li>
            <span class="label">メールアドレス</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonEmail1">
              <input type="text" v-else v-model="businessPersonEmail1" placeholder="担当者メールアドレス">
              <div class="validate_error_messages">{{ validateErrorMessages.businessPersonEmail1 }}</div>
            </div>
          </li>
          <li>
            <span class="label">電話番号</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonTel1">
              <input type="text" v-else v-model="businessPersonTel1" placeholder="担当者電話番号">
              <div class="validate_error_messages">{{ validateErrorMessages.businessPersonTel1 }}</div>
            </div>
          </li>
          <hr>
          <li><span class="parson-label">【サブ担当者】</span></li>
         <li>
            <span class="label">名前</span>
            <span class="sub-label">姓</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonLastNameSub">
              <input type="text" v-else v-model="businessPersonLastNameSub" placeholder="姓">
            </div>
            <span class="sub-label">名</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonFirstNameSub">
              <input type="text" v-else v-model="businessPersonFirstNameSub" placeholder="名">
            </div>
          </li>
          <li>
            <div class="validate_error_messages">{{ validateErrorMessages.businessPersonLastNameSub }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.businessPersonFirstNameSub }}</div>
          </li>
          <li>
            <span class="label">フリガナ</span>
            <span class="sub-label">セイ</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonLastNameKanaSub"
                @input="editBusinessData.businessPersonLastNameKanaSub=inputRestKana($event)">
              <input type="text" v-else v-model="businessPersonLastNameKanaSub" placeholder="セイ"
                @input="businessPersonLastNameKanaSub=inputRestKana($event)">
            </div>
            <span class="sub-label">メイ</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonFirstNameKanaSub"
                @input="editBusinessData.businessPersonFirstNameKanaSub=inputRestKana($event)">
              <input type="text" v-else v-model="businessPersonFirstNameKanaSub" placeholder="メイ"
                @input="businessPersonFirstNameKanaSub=inputRestKana($event)">
            </div>
          </li>
          <li>
            <div class="validate_error_messages">{{ validateErrorMessages.businessPersonLastNameKanaSub }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.businessPersonFirstNameKanaSub }}</div>
          </li>
          <li>
            <span class="label">メールアドレス</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonEmailSub">
              <input type="text" v-else v-model="businessPersonEmailSub" placeholder="メールアドレス">
              <div class="validate_error_messages">{{ validateErrorMessages.businessPersonEmailSub }}</div>
            </div>
          </li>
          <li>
            <span class="label">電話番号</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessPersonTelSub">
              <input type="text" v-else v-model="businessPersonTelSub" placeholder="電話番号">
              <div class="validate_error_messages">{{ validateErrorMessages.businessPersonTelSub }}</div>
            </div>
          </li>
          <hr>
          <li>
            <span class="label">汎用項目１</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessCustom1">
              <input type="text" v-else v-model="businessCustom1" placeholder="汎用項目１">
              <div class="validate_error_messages">{{ validateErrorMessages.businessCustom1 }}</div>
            </div>
          </li>
          <li>
            <span class="label">汎用項目２</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessCustom2">
              <input type="text" v-else v-model="businessCustom2" placeholder="汎用項目２">
              <div class="validate_error_messages">{{ validateErrorMessages.businessCustom2 }}</div>
            </div>
          </li>
          <li>
            <span class="label">汎用項目３</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessCustom3">
              <input type="text" v-else v-model="businessCustom3" placeholder="汎用項目３">
              <div class="validate_error_messages">{{ validateErrorMessages.businessCustom3 }}</div>
            </div>
          </li>
          <li>
            <span class="label">汎用項目４</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessCustom4">
              <input type="text" v-else v-model="businessCustom4" placeholder="汎用項目４">
              <div class="validate_error_messages">{{ validateErrorMessages.businessCustom4 }}</div>
            </div>
          </li>
          <li>
            <span class="label">汎用項目５</span>
            <div class="input-normal">
              <input type="text" v-if="editBusinessData" v-model="editBusinessData.businessCustom5">
              <input type="text" v-else v-model="businessCustom5" placeholder="汎用項目５">
              <div class="validate_error_messages">{{ validateErrorMessages.businessCustom5 }}</div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else class="message">
        <span>得意先を選択してください</span>
      </div>
      <div class="button-area">
      <button type="button" class="main_btn" v-if="editBusinessData && isInput" @click="updatePropertyData">設定</button>
      <button type="button" class="main_btn" v-else-if="isInput" @click="updatePropertyData">登録</button>
      <button type="button" class="main_btn" v-if="editBusinessData && isInput" @click="confirmDelete">削除</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import * as FormUtil from '../../../utils/FormUtil'
import {API_URL} from '../../../constants/App'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'BusinessModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,

      /** 得意先情報 */
      businessId: null,
      businessCode: null,
      businessName: null,
      businessDepartment: null,
      businessCaption: null,
      businessCountry: null,
      businessPostcd: null,
      businessState: null,
      businessCity: null,
      businessStreet: null,
      businessBuilding: null,
      businessFloor: null,
      businessTel: null,
      businessFax: null,
      businessPersonLastName1: null,
      businessPersonFirstName1: null,
      businessPersonLastNameKana1: null,
      businessPersonFirstNameKana1: null,
      businessPersonEmail1: null,
      businessPersonTel1: null,
      businessPersonLastNameSub: null,
      businessPersonFirstNameSub: null,
      businessPersonLastNameKanaSub: null,
      businessPersonFirstNameKanaSub: null,
      businessPersonEmailSub: null,
      businessPersonTelSub: null,
      businessCustom1: null,
      businessCustom2: null,
      businessCustom3: null,
      businessCustom4: null,
      businessCustom5: null,

      /** 編集中データ */
      editBusinessData: null,
      /** 入力エリア表示フラグ */
      isInput: false,
      validateErrorMessages: {}
    }
  },
  methods: {
    /** 新規モーダル */
    showNewModal: function () {
      this.clearData()
      this.isInput = true
      this.modalShown = true
    },
    /** 編集モーダル */
    showEditModal: function (data) {
      this.isInput = data && Object.keys(data).length > 0
      if (this.isInput) {
        this.editBusinessData = Object.assign({}, data)
      }
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.clearData()
      this.modalShown = false
    },
    /** 得意先情報更新 */
    updatePropertyData: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        businessId: this.editBusinessData ? this.editBusinessData.businessId : null,
        businessCode: this.editBusinessData ? this.editBusinessData.businessCode : this.businessCode,
        businessName: this.editBusinessData ? this.editBusinessData.businessName : this.businessName,
        businessDepartment: this.editBusinessData ? this.editBusinessData.businessDepartment : this.businessDepartment,
        businessCaption: this.editBusinessData ? this.editBusinessData.businessCaption : this.businessCaption,
        businessCountry: this.editBusinessData ? this.editBusinessData.businessCountry : this.businessCountry,
        businessPostcd: this.editBusinessData ? this.editBusinessData.businessPostcd : this.businessPostcd,
        businessState: this.editBusinessData ? this.editBusinessData.businessState : this.businessState,
        businessCity: this.editBusinessData ? this.editBusinessData.businessCity : this.businessCity,
        businessStreet: this.editBusinessData ? this.editBusinessData.businessStreet : this.businessStreet,
        businessBuilding: this.editBusinessData ? this.editBusinessData.businessBuilding : this.businessBuilding,
        businessFloor: this.editBusinessData ? this.editBusinessData.businessFloor : this.businessFloor,
        businessTel: this.editBusinessData ? this.editBusinessData.businessTel : this.businessTel,
        businessFax: this.editBusinessData ? this.editBusinessData.businessFax : this.businessFax,
        businessPersonLastName1: this.editBusinessData ? this.editBusinessData.businessPersonLastName1 : this.businessPersonLastName1,
        businessPersonFirstName1: this.editBusinessData ? this.editBusinessData.businessPersonFirstName1 : this.businessPersonFirstName1,
        businessPersonLastNameKana1: this.editBusinessData ? this.editBusinessData.businessPersonLastNameKana1 : this.businessPersonLastNameKana1,
        businessPersonFirstNameKana1: this.editBusinessData ? this.editBusinessData.businessPersonFirstNameKana1 : this.businessPersonFirstNameKana1,
        businessPersonEmail1: this.editBusinessData ? this.editBusinessData.businessPersonEmail1 : this.businessPersonEmail1,
        businessPersonTel1: this.editBusinessData ? this.editBusinessData.businessPersonTel1 : this.businessPersonTel1,
        businessPersonLastNameSub: this.editBusinessData ? this.editBusinessData.businessPersonLastNameSub : this.businessPersonLastNameSub,
        businessPersonFirstNameSub: this.editBusinessData ? this.editBusinessData.businessPersonFirstNameSub : this.businessPersonFirstNameSub,
        businessPersonLastNameKanaSub: this.editBusinessData ? this.editBusinessData.businessPersonLastNameKanaSub : this.businessPersonLastNameKanaSub,
        businessPersonFirstNameKanaSub: this.editBusinessData ? this.editBusinessData.businessPersonFirstNameKanaSub : this.businessPersonFirstNameKanaSub,
        businessPersonEmailSub: this.editBusinessData ? this.editBusinessData.businessPersonEmailSub : this.businessPersonEmailSub,
        businessPersonTelSub: this.editBusinessData ? this.editBusinessData.businessPersonTelSub : this.businessPersonTelSub,
        businessCustom1: this.editBusinessData ? this.editBusinessData.businessCustom1 : this.businessCustom1,
        businessCustom2: this.editBusinessData ? this.editBusinessData.businessCustom2 : this.businessCustom2,
        businessCustom3: this.editBusinessData ? this.editBusinessData.businessCustom3 : this.businessCustom3,
        businessCustom4: this.editBusinessData ? this.editBusinessData.businessCustom4 : this.businessCustom4,
        businessCustom5: this.editBusinessData ? this.editBusinessData.businessCustom5 : this.businessCustom5
      }
      if (!this.editBusinessData) {
        axios.post(API_URL.PLANNING + '/business/create', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['登録しました'],
            onOk: () => {
              this.modalShown = false
              this.$store.dispatch('loadBusinessList', {reload: true})
              this.$emit('getBusinessList')
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      } else {
        axios.post(API_URL.PLANNING + '/business/update', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['変更しました'],
            onOk: () => {
              this.modalShown = false
              this.$store.dispatch('loadBusinessList', {reload: true})
              this.$emit('getBusinessList')
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      }
    },
    /** 削除確認 */
    confirmDelete: function () {
      let modalData = {
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        textAlign: 'left',
        onOk: this.deleteSubmit
      }
      AppUtil.showModal(modalData)
    },
    /** 得意先情報削除 */
    deleteSubmit: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        targetId: this.editBusinessData.businessId
      }
      axios.post(API_URL.PLANNING + '/business/delete', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.showModal = false
          let modalData = {
            messages: ['削除しました。'],
            onOk: () => {
              this.modalShown = false
              this.$store.dispatch('loadBusinessList', {reload: true})
              this.$emit('getBusinessList')
            }
          }
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    inputRestKana: function (event) {
      // テキスト補正
      let str = FormUtil.restKana(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    },
    clearData: function () {
      this.businessId = null
      this.businessCode = null
      this.businessName = null
      this.businessDepartment = null
      this.businessCaption = null
      this.businessCountry = null
      this.businessPostcd = null
      this.businessState = null
      this.businessCity = null
      this.businessStreet = null
      this.businessBuilding = null
      this.businessFloor = null
      this.businessTel = null
      this.businessFax = null
      this.businessPersonLastName1 = null
      this.businessPersonFirstName1 = null
      this.businessPersonLastNameKana1 = null
      this.businessPersonFirstNameKana1 = null
      this.businessPersonEmail1 = null
      this.businessPersonTel1 = null
      this.businessPersonLastNameSub = null
      this.businessPersonFirstNameSub = null
      this.businessPersonLastNameKanaSub = null
      this.businessPersonFirstNameKanaSub = null
      this.businessPersonEmailSub = null
      this.businessPersonTelSub = null
      this.businessCustom1 = null
      this.businessCustom2 = null
      this.businessCustom3 = null
      this.businessCustom4 = null
      this.businessCustom5 = null
      this.editBusinessData = null
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.data-area{
    max-height: 630px;
    overflow: auto;
    padding: 20px;
    li {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;
      @media (max-width: 768px) {
        flex-direction: column;
      }
     .label {
        flex: none;
        display: inline-block;
        width: 150px;
        text-align: left;
        font-weight: bold;
        margin-left: 20px;
        margin-top: auto;
        margin-bottom: auto;
        @media (max-width: 768px) {
          text-align: left
        }
      }
      .sub-label {
        flex: none;
        display: inline-block;
        width: 40px;
        text-align: left;
        margin-left: 20px;
        margin-top: auto;
        margin-bottom: auto;
        @media (max-width: 768px) {
          text-align: left
        }
      }
      .parson-label {
        font-weight: bold;
        font-size: 16px;
        border-bottom: solid 1px black;
      }
      .input-normal {
        flex: 1 1 auto;
        display: block;
        input,
        textarea{
          box-sizing: border-box;
          width: 100%;
          max-width: 450px;
        }
      }
    }
  }
.modal-main{
  max-height: 90%;
  min-width: 750px;
  max-width: 800px;
}
.count_limit{
  font-size: 8px;
}
.message{
  margin: 30px;
}
.required {
  color: #ff0000;
}
.validate_error_messages {
  color: #dc3545;
  text-align: left;
  min-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/BusinessModal.vue